import $ from 'jquery';

function getSignedUploadUrl(contentType, fileName) {
  return fetch(
    '/file-upload-get-signed-url-cloudflare?' +
      new URLSearchParams({
        contentType: contentType,
        fileName: fileName
      }),
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  ).then(response => {
    return response.json();
  });
}

$(document).ready(function () {
  // user avatar file upload?
  $('#new-ai-avatar').on('change', function () {
    if (
      this.multiple ||
      $(this).closest('#datasets-file-upload-button').length ||
      document.querySelector('#new-ai-avatar-image')
    ) {
      return;
    }
    var files = this.files;

    // this can be a file from e.g. <input type="file"/>
    const file = files[0];
    const name = file.name;
    const type = file.type;
    let uploadToSignedUrl = function (signedUrl) {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl.url, true);
      xhr.onload = () => {
        const status = xhr.status;
        if (status === 200) {
          // save signedUrl.object_path to the form
          $('#newaiavatarurl').val(signedUrl.object_path);
          $('#new-ai-avatar-image').html(
            `<img src="https://appstatic.app.nz/${signedUrl.object_path}" width="81" height="81"/>`
          );
        } else {
          alert('Something went wrong!');
        }
      };

      xhr.onerror = () => {
        alert('Something went wrong');
      };
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.send(file);
      //track
      // trackEvent('user', 'upload', 'avatar');
    };
    getSignedUploadUrl(type, name).then(uploadToSignedUrl);
  });

  // delete files
  $(document).on('click', '#treeView .file-delete-icon', function (e) {
    e.preventDefault();
    e.stopPropagation();
    // spinner
    // $(this).closest('.file').find('.file-delete-icon').addClass('fa-spinner fa-spin');
    var $el = $(this);
    var file_name = $el.parent().find('.file-name').text();
    dataAccessor
      .deleteFile(file_name)
      .then(function (response) {
        var fileNames = response.files.map(x =>
          x.indexOf('-') > -1 ? x.slice(x.indexOf('-') + 1) : x
        );
        createTreeView(fileNames, '#treeView', '', true, response.folders || []);
        renderFailedUploads(userData);
      })
      .catch(function (error) {
        console.log(error);
      });

    $(this).closest('.file').remove(); // remove parent
    return false;
  });
  // user

  document.querySelectorAll('.drop-zone__input').forEach(inputElement => {
    const dropZoneElement = inputElement.closest('.drop-zone');
    if (!dropZoneElement || !inputElement.multiple) {
      return;
    }

    dropZoneElement.addEventListener('click', e => {
      $(inputElement).click();
      // e.preventDefault();
      // e.stopPropagation();
    });
    $(inputElement).on('click', function stopProp(e) {
      e.stopPropagation();
    }); // dont close background modal

    inputElement.addEventListener('change', e => {
      if (inputElement.files.length) {
        updateThumbnail(dropZoneElement, inputElement.files);
      }
    });

    dropZoneElement.addEventListener('dragover', e => {
      e.preventDefault();
      dropZoneElement.classList.add('drop-zone--over');
    });

    ['dragleave', 'dragend'].forEach(type => {
      dropZoneElement.addEventListener(type, e => {
        dropZoneElement.classList.remove('drop-zone--over');
      });
    });

    dropZoneElement.addEventListener('drop', e => {
      e.preventDefault();

      if (e.dataTransfer.files.length) {
        inputElement.files = e.dataTransfer.files;
        updateThumbnail(dropZoneElement, e.dataTransfer.files);
      }

      dropZoneElement.classList.remove('drop-zone--over');
    });
  });
});

function getSignedURLAndUpload(file, type, name) {
  // For development/local environments, try server upload first to avoid CORS issues
  if (
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'helix.local'
  ) {
    console.log('Development environment detected, using server upload');
    return uploadViaServer(file, type, name);
  }

  // For production, try direct upload first, then fallback to server
  let signedUploadUrlPromise = getSignedUploadUrl(type, name);

  function uploadToSignedUrlPromise(signedUrl) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl.url, true);
      xhr.onload = () => {
        const status = xhr.status;
        if (status === 200) {
          // save signedUrl.object_path to the form
          resolve(signedUrl);
        } else {
          reject(new Error(`Direct upload failed with status ${status}`));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Direct upload network error'));
      };
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.send(file);
    });
  }

  return signedUploadUrlPromise.then(uploadToSignedUrlPromise).catch(error => {
    console.warn('Direct R2 upload failed, falling back to server upload:', error);
    // Always use server upload as fallback to avoid CORS issues
    return uploadViaServer(file, type, name);
  });
}

function uploadViaServer(file, type, name) {
  return new Promise((resolve, reject) => {
    if (!window.userData || !window.userData.secret) {
      reject(new Error('User not authenticated'));
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('secret', window.userData.secret);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/upload-file', true);

    xhr.onload = () => {
      if (xhr.status === 200) {
        try {
          const response = JSON.parse(xhr.responseText);
          if (response.success) {
            // Format response to match expected structure
            resolve({
              object_path: response.filename,
              url: `/api/files/${response.filename}`,
              filename: response.filename
            });
          } else {
            reject(new Error(response.error || 'Upload failed'));
          }
        } catch (e) {
          reject(new Error('Invalid response from server'));
        }
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => {
      reject(new Error('Upload request failed'));
    };

    xhr.send(formData);
  });
}

window.importFromDriveUrl = function () {
  const url = window.prompt('Paste a Google Drive or Google Sheets link (shared or public):');
  if (!url || !url.trim()) {
    return;
  }
  if (!window.userData || !window.userData.secret) {
    window.alert('Please sign in first');
    return;
  }

  const looksPrivate = (status, msg) =>
    status === 502 || (status === 400 && /public|private|permission|access token/i.test(msg || ''));

  const connectDriveThenRetry = attempt => {
    const popup = window.open(
      '/auth/google-drive/start?secret=' + encodeURIComponent(window.userData.secret),
      'drive-auth',
      'width=550,height=700'
    );
    if (!popup) {
      window.alert('Popup blocked. Please allow popups and try again.');
      return;
    }
    const onMessage = ev => {
      if (!ev.data || ev.data.type !== 'drive-connected') return;
      window.removeEventListener('message', onMessage);
      attempt(true);
    };
    window.addEventListener('message', onMessage);
    setTimeout(() => window.removeEventListener('message', onMessage), 300000);
  };

  const attempt = isRetry => {
    $('#datasets-spinner').show();
    fetch('/api/import-drive-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ secret: window.userData.secret, url: url.trim() })
    })
      .then(r =>
        r
          .json()
          .catch(() => ({}))
          .then(data => ({ ok: r.ok, status: r.status, data }))
      )
      .then(({ ok, status, data }) => {
        if (!ok || !data || !data.success || !data.filename) {
          const msg = (data && data.error) || 'Drive import failed';
          if (
            !isRetry &&
            looksPrivate(status, msg) &&
            window.confirm('File may be private. Connect Google Drive and retry?')
          ) {
            connectDriveThenRetry(attempt);
            return;
          }
          throw new Error(msg);
        }
        return dataAccessor.saveAllNewFiles([data.filename]).then(function (response) {
          var fileNames = response.files.map(x =>
            x.indexOf('-') > -1 ? x.slice(x.indexOf('-') + 1) : x
          );
          createTreeView(fileNames, '#treeView', '', true, response.folders || []);
          userData.file_names = fileNames;
          renderFailedUploads(userData);
        });
      })
      .catch(err => {
        console.error('Drive import failed:', err);
        window.alert('Drive import failed: ' + (err && err.message ? err.message : 'unknown error'));
      })
      .finally(() => {
        $('#datasets-spinner').hide();
      });
  };

  attempt(false);
};

window.updateThumbnail = function (target, files) {
  // this can be a file from e.g. <input type="file"/>
  //     const file = files[0];
  // spinner
  // $(this).closest('.file').find('.file-delete-icon').addClass('fa-spinner fa-spin');
  $('#datasets-spinner').show();
  var promises = [];
  var names = [];
  for (var i = 0; i < files.length; i++) {
    var file = files[i];
    const name = file.name;
    names.push(name);
    const type = file.type;
    var promise = getSignedURLAndUpload(file, type, name);
    promises.push(promise);
  }
  Promise.all(promises).then(function (values) {
    console.log(values);
    //finished uploading
    //todo check all success
    var object_paths = values.map(function (value) {
      return value.object_path;
    });
    // createTreeView(object_paths, "#treeView", "insert_drive_file");
    dataAccessor
      .saveAllNewFiles(object_paths)
      .then(function (response) {
        var fileNames = response.files.map(x =>
          x.indexOf('-') > -1 ? x.slice(x.indexOf('-') + 1) : x
        );
        createTreeView(fileNames, '#treeView', '', true, response.folders || []);
        userData.file_names = fileNames;
        renderFailedUploads(userData);
      })
      .catch(function (error) {})
      .finally(function () {
        $('#datasets-spinner').hide();
      });
  });
};
